export const USER_LOGOUT = 'USER_LOGOUT';

export function logout() {
    return {
        type: USER_LOGOUT
    }
}

export const RESET_STATE = 'RESET_STATE';

export function resetState() {
    return {
        type: RESET_STATE
    }
}

// TODO clearup the code below later
export const LOGIN_TELEGRAM_REQUEST = 'LOGIN_TELEGRAM_REQUEST';
export const LOGIN_TELEGRAM_COMMIT = 'LOGIN_TELEGRAM_COMMIT';
export const LOGIN_TELEGRAM_ROLLBACK = 'LOGIN_TELEGRAM_ROLLBACK';

export function loginTelegram(telegramUser) {
    return {
        type: LOGIN_TELEGRAM_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/auth/login`,
                    body: JSON.stringify(telegramUser),
                    headers: { "Content-Type": "text/plain" },
                    method: "POST",
                },
                commit: {type: LOGIN_TELEGRAM_COMMIT},
                rollback: {type: LOGIN_TELEGRAM_ROLLBACK}
            }
        }
    }
}

export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';

export function clearAuthError() {
    return {
        type: CLEAR_AUTH_ERROR
    }
}

export const LOGIN_EMAIL = 'LOGIN_EMAIL';

export function loginEmail(data) {
    return {
        type: LOGIN_EMAIL,
        payload: data,
    }
}

export const COMPLETE_SIGNUP_REQUEST = "COMPLETE_SIGNUP_REQUEST";
export const COMPLETE_SIGNUP_COMMIT = "COMPLETE_SIGNUP_COMMIT";
export const COMPLETE_SIGNUP_ROLLBACK = "COMPLETE_SIGNUP_ROLLBACK";

export function completeSignUp(formData, token) {
    return {
        type: COMPLETE_SIGNUP_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/auth/register`,
                    json: formData,
                    method: "POST",
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                },
                commit: {type: COMPLETE_SIGNUP_COMMIT},
                rollback: {type: COMPLETE_SIGNUP_ROLLBACK}
            }
        }
    }
}

export const PENDING_TELEGRAM_CHANNELS_REQUEST = 'PENDING_TELEGRAM_CHANNELS_REQUEST';
export const PENDING_TELEGRAM_CHANNELS_COMMIT = 'PENDING_TELEGRAM_CHANNELS_COMMIT';
export const PENDING_TELEGRAM_CHANNELS_ROLLBACK = 'PENDING_TELEGRAM_CHANNELS_ROLLBACK';

export function fetchPendingTelegramChannels(token) {
    return {
        type: PENDING_TELEGRAM_CHANNELS_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/resources/pending_channels`,
                    method: "POST",
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                },
                commit: {type: PENDING_TELEGRAM_CHANNELS_COMMIT},
                rollback: {type: PENDING_TELEGRAM_CHANNELS_ROLLBACK}
            }
        }
    }
}


export const ADD_PENDING_PLAN = "ADD_PENDING_PLAN";

export function addPendingPlan(price, currency, period) {
    return {
        type: ADD_PENDING_PLAN,
        price,
        currency,
        period
    }
}


export const CLEAR_PENDING_PLAN = "CLEAR_PENDING_PLAN";

export function clearPendingPlan() {
    return {
        type: CLEAR_PENDING_PLAN,
    }
}

export const FETCH_PROJECT_REQUEST = 'FETCH_PROJECT_REQUEST';
export const FETCH_PROJECT_COMMIT = 'FETCH_PROJECT_COMMIT';
export const FETCH_PROJECT_ROLLBACK = 'FETCH_PROJECT_ROLLBACK';

export function fetchProject(accessToken, projectId) {
    return {
        type: FETCH_PROJECT_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/project`,
                    method: "POST",
                    body: JSON.stringify({ accessToken, projectId }),
                    headers: { "Content-Type": "text/plain" }
                },
                commit: {type: FETCH_PROJECT_COMMIT},
                rollback: {type: FETCH_PROJECT_ROLLBACK}
            }
        }
    }
}

export const FETCH_PERMISSIONS_REQUEST = 'FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_COMMIT = 'FETCH_PERMISSIONS_COMMIT';
export const FETCH_PERMISSIONS_ROLLBACK = 'FETCH_PERMISSIONS_ROLLBACK';
export const CLEAR_PERMISSIONS = 'CLEAR_PERMISSIONS';

export function fetchPermissions({ accessToken, projectId }) {
    return {
        type: FETCH_PERMISSIONS_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/user/permissions`,
                    method: "POST",
                    body: JSON.stringify({ accessToken, projectId }),
                    headers: { "Content-Type": "text/plain" }
                },
                commit: {type: FETCH_PERMISSIONS_COMMIT},
                rollback: {type: FETCH_PERMISSIONS_ROLLBACK}
            }
        }
    }
}

export function clearPermissions() {
    return {
        type: CLEAR_PERMISSIONS
    }
}

export const UPDATE_PROJECT = 'UPDATE_PROJECT';

export const updateProject = (project) => ({
    type: UPDATE_PROJECT,
    payload: project,
});

export const FETCH_MY_PROJECTS_REQUEST = 'FETCH_MY_PROJECTS_REQUEST';
export const FETCH_MY_PROJECTS_COMMIT = 'FETCH_MY_PROJECTS_COMMIT';
export const FETCH_MY_PROJECTS_ROLLBACK = 'FETCH_MY_PROJECTS_ROLLBACK';

export function fetchMyProjects(accessToken) {
    return {
        type: FETCH_MY_PROJECTS_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/project/my`,
                    method: "POST",
                    body: JSON.stringify({ accessToken }),
                    headers: { "Content-Type": "text/plain" }
                },
                commit: {type: FETCH_MY_PROJECTS_COMMIT},
                rollback: {type: FETCH_MY_PROJECTS_ROLLBACK}
            }
        }
    }
}

export const CHECKOUT_SESSION_REQUEST = 'CHECKOUT_SESSION_REQUEST';
export const CHECKOUT_SESSION_COMMIT = 'CHECKOUT_SESSION_COMMIT';
export const CHECKOUT_SESSION_ROLLBACK = 'CHECKOUT_SESSION_ROLLBACK';

export function checkoutSession(data) {
    return {
        type: CHECKOUT_SESSION_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/stripeCheckoutSession`,
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: { "Content-Type": "application/json" }
                },
                commit: {type: CHECKOUT_SESSION_COMMIT},
                rollback: {type: CHECKOUT_SESSION_ROLLBACK}
            }
        }
    }
}

export const SET_CURRENT_PROJECT_ID = "SET_CURRENT_PROJECT_ID";

export function setCurrentProjectId(projectId) {
    return {
        type: SET_CURRENT_PROJECT_ID,
        projectId
    }
}

export const SET_CURRENT_PROJECT = "SET_CURRENT_PROJECT";

export function setCurrentProject(projectId, project) {
    return {
        type: SET_CURRENT_PROJECT,
        projectId,
        project
    }
}

export const CLEAR_PROJECT_USERS = 'CLEAR_PROJECT_USERS';

export function clearProjectUsers(projectId) {
    return {
        type: CLEAR_PROJECT_USERS,
        meta: {
            projectId: projectId
        }
    }
}

export const SET_PROJECT_USERS_PAGINATION_FILTER = 'SET_PROJECT_USERS_PAGINATION_FILTER';

export function setProjectUsersPaginationFilter(projectId, pageSize, pageNumber) {
    return {
        type: SET_PROJECT_USERS_PAGINATION_FILTER,
        meta: {
            projectId: projectId,
            pageSize: pageSize,
            pageNumber: pageNumber
        }
    }
}

export const FETCH_PROJECT_USERS_REQUEST = 'FETCH_PROJECT_USERS_REQUEST';
export const FETCH_PROJECT_USERS_COMMIT = 'FETCH_PROJECT_USERS_COMMIT';
export const FETCH_PROJECT_USERS_ROLLBACK = 'FETCH_PROJECT_USERS_ROLLBACK';

export function fetchProjectUsers(token, projectId, startKey) {
    return {
        type: FETCH_PROJECT_USERS_REQUEST,
        meta: {
            projectId: projectId,
            startKey: startKey,
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/project/users`,
                    method: "POST",
                    json: {
                        projectId: projectId,
                        startKey: startKey,
                        limit: 1
                    },
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                },
                commit: {type: FETCH_PROJECT_USERS_COMMIT, meta: {projectId, startKey}},
                rollback: {type: FETCH_PROJECT_USERS_ROLLBACK, meta: {projectId, startKey}}
            }
        }
    }
}


export const FETCH_PROJECT_PAYMENTS_REQUEST = 'FETCH_PROJECT_PAYMENTS_REQUEST';
export const FETCH_PROJECT_PAYMENTS_COMMIT = 'FETCH_PROJECT_PAYMENTS_COMMIT';
export const FETCH_PROJECT_PAYMENTS_ROLLBACK = 'FETCH_PROJECT_PAYMENTS_ROLLBACK';

export function fetchProjectPayments(token, projectId) {
    return {
        type: FETCH_PROJECT_PAYMENTS_REQUEST,
        meta: {
            projectId: projectId,
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/project/payments`,
                    method: "POST",
                    json: {
                        projectId: projectId
                    },
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                },
                commit: {type: FETCH_PROJECT_PAYMENTS_COMMIT, meta: {projectId}},
                rollback: {type: FETCH_PROJECT_PAYMENTS_ROLLBACK, meta: {projectId}}
            }
        }
    }
}

export const FETCH_PROJECT_SUBSCRIPTIONS_REQUEST = 'FETCH_PROJECT_SUBSCRIPTIONS_REQUEST';
export const FETCH_PROJECT_SUBSCRIPTIONS_COMMIT = 'FETCH_PROJECT_SUBSCRIPTIONS_COMMIT';
export const FETCH_PROJECT_SUBSCRIPTIONS_ROLLBACK = 'FETCH_PROJECT_SUBSCRIPTIONS_ROLLBACK';

export function fetchProjectSubscriptions(token, projectId) {
    return {
        type: FETCH_PROJECT_SUBSCRIPTIONS_REQUEST,
        meta: {
            projectId: projectId,
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/project/subscriptions`,
                    method: "POST",
                    json: {
                        projectId: projectId
                    },
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                },
                commit: {type: FETCH_PROJECT_SUBSCRIPTIONS_COMMIT, meta: {projectId}},
                rollback: {type: FETCH_PROJECT_SUBSCRIPTIONS_ROLLBACK, meta: {projectId}}
            }
        }
    }
}

export const FETCH_PROJECT_PLANS_REQUEST = 'FETCH_PROJECT_PLANS_REQUEST';
export const FETCH_PROJECT_PLANS_COMMIT = 'FETCH_PROJECT_PLANS_COMMIT';
export const FETCH_PROJECT_PLANS_ROLLBACK = 'FETCH_PROJECT_PLANS_ROLLBACK';

export function fetchProjectPlans(token, projectId) {
    return {
        type: FETCH_PROJECT_PLANS_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/project/plans`,
                    method: "POST",
                    json: {
                        projectId: projectId
                    },
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                },
                commit: {type: FETCH_PROJECT_PLANS_COMMIT, meta: {projectId}},
                rollback: {type: FETCH_PROJECT_PLANS_ROLLBACK, meta: {projectId}}
            }
        }
    }
}

export const FETCH_PROJECT_RESOURCES_REQUEST = 'FETCH_PROJECT_RESOURCES_REQUEST';
export const FETCH_PROJECT_RESOURCES_COMMIT = 'FETCH_PROJECT_RESOURCES_COMMIT';
export const FETCH_PROJECT_RESOURCES_ROLLBACK = 'FETCH_PROJECT_RESOURCES_ROLLBACK';

export function fetchProjectResources(token, projectId) {
    return {
        type: FETCH_PROJECT_RESOURCES_REQUEST,
        meta: {
            projectId: projectId,
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/project/resources`,
                    method: "POST",
                    json: {
                        projectId: projectId
                    },
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                },
                commit: {type: FETCH_PROJECT_RESOURCES_COMMIT, meta: {projectId}},
                rollback: {type: FETCH_PROJECT_RESOURCES_ROLLBACK, meta: {projectId}}
            }
        }
    }
}

export const UPDATE_PREVURL = 'UPDATE_PREVURL';

export const updatePrevUrl = (url) => ({
    type: UPDATE_PREVURL,
    payload: {
        prevUrl: url,
    },
});

export const UPDATE_EMAIL_CONFIRM_MODAL = 'UPDATE_EMAIL_CONFIRM_MODAL';

export const updateEmailConfirmModal = (toShow) => ({
    type: UPDATE_EMAIL_CONFIRM_MODAL,
    payload: {
        emailConfirmModal: toShow,
    },
});

export const FETCH_SUBSCRIPTION_NOTIFICATIONS_REQUEST = 'FETCH_SUBSCRIPTION_NOTIFICATIONS_REQUEST';
export const FETCH_SUBSCRIPTION_NOTIFICATIONS_COMMIT = 'FETCH_SUBSCRIPTION_NOTIFICATIONS_COMMIT';
export const FETCH_SUBSCRIPTION_NOTIFICATIONS_ROLLBACK = 'FETCH_SUBSCRIPTION_NOTIFICATIONS_ROLLBACK';
export const UPDATE_SUBSCRIPTION_DATA = 'UPDATE_SUBSCRIPTION_DATA';

export function fetchSubscriptionNotifications(accessToken) {
    return {
        type: FETCH_SUBSCRIPTION_NOTIFICATIONS_REQUEST,
        meta: {
            offline: {
                effect: {
                    url: `${process.env.REACT_APP_API_URL}/user/subscription-status`,
                    method: "POST",
                    body: JSON.stringify({ accessToken }),
                    headers: { "Content-Type": "text/plain" }
                },
                commit: {type: FETCH_SUBSCRIPTION_NOTIFICATIONS_COMMIT},
                rollback: {type: FETCH_SUBSCRIPTION_NOTIFICATIONS_ROLLBACK}
            }
        }
    }
}

export function updateSubscriptionDataFromHook(data) {
    return {
        type: UPDATE_SUBSCRIPTION_DATA,
        payload: data
    }
}

